export const anchorLinkScroller = (): void => {
  if (window.jQuery !== undefined) {
    jQuery('a[href*=\\#]').on('click', function (event) {
      if (this.pathname === window.location.pathname) {
        event.preventDefault()

        let headerHeight = (jQuery('header'))
          ? jQuery('header').height()
          : 0

        let localLink = jQuery(this)

        let specialScroll = jQuery(localLink[0].hash)

        if (specialScroll.length > 0) {
          jQuery('html, body').animate({
            scrollTop: specialScroll.offset().top - headerHeight
          }, 1300)

          setTimeout(() => {
            jQuery('html, body').animate({
              scrollTop: specialScroll.offset().top - headerHeight
            }, 0)
          }, 1300)
        }
      }
    })
  }
}
